import { appSubDomain } from '../../config';

// use flag useSubDomain to share with Sonnet digital for cookies created on Digital FNOL
export function createCookie(name, value, days, useSubDomain) {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `;expires=${date.toGMTString()}`;
  }
  if (useSubDomain) {
    document.cookie = `${name}=${value}${expires};  domain=${appSubDomain}; path=/`;
    return;
  }
  document.cookie = `${name}=${value}${expires};  path=/`;
}

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};

export const deleteCookie = (name, useSubDomain) => {
  if (getCookie(name)) {
    if (useSubDomain) {
      document.cookie = `${name}=; Path=/; domain=${appSubDomain}; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    } else {
      document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    }
  }
};

// list of cookies being used, for tracking
export const cookies = {
  CMSPreferredCulture: 'CMSPreferredCulture',
  claimSupportId: 'claim_support_id',
  sonnetAddressBookUId: 'abuid',
  chatToken: 'chat-token',
  fullStorySupportId: 'fullstory_support_id',
  userProvince: 'userProvince'
};
